export const otherOption = {
    value: "OTHER",
    label: "Inny powód"
} as const;
export const otherOption = {
    value: "OTHER",
    label: "Inny powód"
} as const;
